import React from 'react';
import './App.css';
import {Routes, Route, BrowserRouter} from "react-router-dom";
import Category from "./pages/categories/Category";
import Items from "./pages/items/Items";
import Item from "./pages/item/Item";
import Cart from "./pages/cart/Cart";
import AdminItems from "./pages/admin/items/AdminItems";
import AdminOrders from "./pages/admin/orders/AdminOrders";
import AdminCategory from "./pages/admin/category/AdminCategory";
import Login from "./pages/admin/login/Login";
import Header from "./pages/header/Header";
import Footer from "./pages/header/Footer";
import PaymentDelivery from "./pages/paymentdelivery/PaymentDelivery";
import About from "./pages/about/About";


function App() {
  return (
      // eslint-disable-next-line react/jsx-no-undef
      <BrowserRouter>
        {/*<Header/>*/}
          {/* eslint-disable-next-line react/jsx-no-undef */}
        <Header />
        <Routes>
          {/* eslint-disable-next-line react/jsx-no-undef */}
          <Route path="/" element={<Category/>} />
          <Route path="/categories" element={<Category/>} />
          <Route path="/items" element={<Items/>} />
          <Route path="/item" element={<Item/>} />
          <Route path="/cart" element={<Cart/>} />

            <Route path="/admin-oks/orders" element={<AdminOrders/>} />
            <Route path="/admin-oks/categories" element={<AdminCategory/>} />
            <Route path="/admin-oks/items" element={<AdminItems/>} />
            <Route path="/admin-oks/login" element={<Login/>} />
            <Route path="/payment" element={<PaymentDelivery />} />
            <Route path="/about" element={<About />} />



        </Routes>
        <Footer />
      </BrowserRouter>
  );
}

export default App;
